exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content-root {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.empty-friends-text{\n    margin-top: 50px;\n    font: 18px Helvetica;\n    font-weight: bold;\n    color: #fff;\n    margin-left:auto;\n    margin-right:auto;\n}\n\n@media only screen and (max-width: 600px) {\n    .tab-content-root {\n        flex-direction: column;\n        margin-top: 0px;\n    }\n    .empty-friends-text{\n        margin-top: 40vw;\n        font: 5.5vw Helvetica;\n        font-weight: bold;\n    }\n}\n", ""]);

// exports
